export default "__VITE_ASSET__gg0BR07i__"